import React from 'react'

const DocuSingDeliver = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.5 4L4.75 10.75L1 7" stroke="#1E90FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M16.5 6L8.25 14.25L7 13" stroke="#1E90FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  )
}

export default DocuSingDeliver